<template>
  <vetalfa-dialog
    v-on:dialogClose="dialogModel = false"
    :bottom="_xsOnly()"
    :toggleModel="dialogModel"
    :fullscreen="false"
    max-width="700px"
    :height="dialogHeight"
    background-color="secondary"
    :smallHeader="false"
    :featureMode="false"
    :dialogHeader="{
      title: title,
    }"
  >
    <template v-slot:header>
      <v-row no-gutters justify="start">
        <v-text-field
          class="mx-3 mt-5 mb-2 white"
          outlined
          dense
          clearable
          v-model="search"
          :loading="loading"
          :placeholder="_getLabel('SEARCH_TEXT')"
          hide-details
        >
          <template v-slot:prepend-inner>
            <v-icon color="primary" class="mr-2">
              {{ _icon("magnify") }}
            </v-icon>
          </template>
        </v-text-field>
      </v-row>
      <v-row
        v-if="filters && filters.length"
        no-gutters
        justify="start"
        class="mt-3 ml-3"
      >
        <v-chip-group
          v-model="filterModel"
          dense
          mandatory
          class="ma-0 pa-0 white--text"
          active-class="primary white--text"
        >
          <v-chip
            v-for="(filter, index) in filters"
            :key="`search-chip-group-${filter}`"
            small
            :outlined="filterModel != index"
            color="primary"
            >{{ filter }}</v-chip
          >
        </v-chip-group>
      </v-row>
    </template>

    <vetalfa-ads
      v-show="!items.length && !search && !loading"
      :index="ads"
      class="px-3 mt-4"
    ></vetalfa-ads>
    <v-row v-if="(!items.length && search) || loading" no-gutters>
      <v-row no-gutters justify="center" class="mt-16">
        <v-progress-circular
          :size="36"
          :width="2"
          color="primary"
          indeterminate
          v-if="loading"
        ></v-progress-circular>
        <p v-else class="mx-3 text-center subtitle-2">
          {{ noDataPlaceholder }}
        </p>
      </v-row>
    </v-row>
    <v-row no-gutters v-else-if="!items.length" class="mt-4">
      <v-col v-if="placeholder" class="ma-0 pa-0" cols="12">
        <v-row class="ma-0 pa-0" justify="center">
          <v-img
            position="center"
            height="60px"
            class="ma-0 pa-0"
            :src="searchImage"
            :lazy-src="searchImage"
            max-width="300"
            contain
          ></v-img>
        </v-row>
      </v-col>
      <v-col v-if="placeholder" class="ma-0 pa-0 px-5" cols="12">
        <v-row no-gutters justify="center">
          <p
            class="text-center ma-0 pa-0 mt-5 subtitle-2 grey--text"
            style="max-width: 400px"
            v-html="placeholder"
          ></p>
        </v-row>
      </v-col>
      <v-col class="ma-0 pa-0" cols="12">
        <slot name="placeholder"></slot>
      </v-col>
    </v-row>
    <div v-if="!loading">
      <v-row
        no-gutters
        v-for="(item, searchItemIndex) in items"
        :key="`search-item-${searchItemIndex}`"
        class="mx-4 mt-1 mb-2"
      >
        <slot name="item" :item="item"></slot>
      </v-row>
    </div>

    <template v-slot:actions>
      <v-row no-gutters justify="center" class="py-3">
        <slot name="appendItem"></slot>
      </v-row>
    </template>
  </vetalfa-dialog>
</template>

<script>
function debounce(fn, delay) {
  let timeoutID;
  return function (...args) {
    clearTimeout(timeoutID);
    timeoutID = setTimeout(() => fn.apply(this, args), delay);
  };
}
import { mdiCloseCircleOutline } from "@mdi/js";
import images from "@/constants/images.js";
export default {
  name: "Search",
  props: {
    ads: {
      type: String,
      required: false,
      default: "default",
    },
    searchTriggerModel: {
      required: false,
      default: false,
    },
    items: {
      type: Array,
      required: true,
      default: [],
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    noDataPlaceholder: {
      type: String,
      required: false,
      default: "",
    },
    loadingTrigger: {
      required: false,
    },
    filters: {
      type: Array,
      required: false,
      default: () => [],
    },
    filterValue: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {},
  components: {},
  methods: {
    fetchData() {
      this.$emit("fetch-data", {
        search: this.search,
        filter: this.filterModel,
      });
    },
    debouncedFetchData: debounce(function () {
      this.fetchData();
    }, 500),
  },
  watch: {
    searchTriggerModel(val) {
      this.dialogModel = !!val;
    },
    search() {
      this.loading = true;
      this.debouncedFetchData();
    },
    loadingTrigger(val) {
      if (val) {
        this.loading = false;
      }
    },
    filterModel() {
      this.loading = true;
      this.fetchData();
    },
  },
  data() {
    return {
      dialogModel: false,
      search: "",
      loading: false,
      filterModel: undefined,
      mdiCloseCircleOutline,
      searchImage: images.SEARCH,
      dialogHeight: null,
    };
  },
  mounted() {
    if (typeof this.filterValue === "number") {
      this.filterModel = this.filterValue;
    }
    this.dialogHeight = this._getDialogHeight(this._isIos() ? 0.9 : 0.95);
  },
};
</script>
